module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "id": "optin-table",
      "data": _vm.channels
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": "Channel",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('social-icon', {
          staticClass: "fa fa-fw",
          attrs: {
            "type": scope.row.type
          }
        }), _vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optins",
      "align": "center",
      "label": "Opt-ins",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.optins),
            callback: function($$v) {
              _vm.$set(scope.row, "optins", $$v)
            },
            expression: "scope.row.optins"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optouts",
      "align": "center",
      "label": "Exclude opt-outs",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.optouts),
            callback: function($$v) {
              _vm.$set(scope.row, "optouts", $$v)
            },
            expression: "scope.row.optouts"
          }
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7696c7ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/OptinsFilter.vue
// module id = 3345
// module chunks = 3